import { useIsomorphicLayoutEffect } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";
import { LottieIds, Lottie, ThemeConfig } from "@swiggy-private/cart-types";
import { CartHeaderLottieState } from "@cart-client/contexts/CartHeaderLottieContext";

interface UseSkipAnimationFinalStateParams {
    skipAnimationShowFinalState?: boolean;
    hasLottie: boolean;
    cartType: string;
    lottieArray: Lottie[];
    enabledOverlayId: string | null;
    onCloseOverlay: VoidFunction;
    setCartHeaderLottieState: React.Dispatch<React.SetStateAction<CartHeaderLottieState>>;
    themeConfig?: ThemeConfig;
}

/**
 * Hook to handle skipping header lottie animation and showing final state directly.
 * Used when magic items lottie has not played yet in the session.
 */
export const useSkipAnimationFinalState = ({
    skipAnimationShowFinalState,
    hasLottie,
    cartType,
    lottieArray,
    enabledOverlayId,
    onCloseOverlay,
    setCartHeaderLottieState,
    themeConfig,
}: UseSkipAnimationFinalStateParams): void => {
    useIsomorphicLayoutEffect(() => {
        if (skipAnimationShowFinalState && !isEmpty(cartType)) {
            setCartHeaderLottieState((prev) => ({
                ...prev,
                cartType: cartType,
                hasLottie: hasLottie,
                showAnimation: true,
                themeChange: true,
                showFinalState: true,
                startAnimation: false,
                hideTheme: false,
                lottieArray: lottieArray,
                themeConfig: themeConfig,
            }));
            // Close overlay if it was registered
            if (enabledOverlayId === LottieIds.CART_HEADER_LOTTIE) {
                onCloseOverlay();
            }
        }
    }, [
        skipAnimationShowFinalState,
        hasLottie,
        cartType,
        lottieArray,
        enabledOverlayId,
        onCloseOverlay,
        setCartHeaderLottieState,
        themeConfig,
    ]);
};
